import { render, staticRenderFns } from "./locator.vue?vue&type=template&id=156d12a0&shadow"
import script from "./locator.vue?vue&type=script&lang=js&shadow"
export * from "./locator.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports